import * as React from 'react'
import styled from 'styled-components';
import CloseIcon from "./closeIcon.js"

class CustomMultiValueRemove extends React.Component {
  buttonRef = React.createRef();

  componentDidMount = () => {
    if (this.buttonRef.current != null) {
      this.buttonRef.current.addEventListener("keydown", this.handleKeydown);
    }
  }

  componentWillUnmount = () => {
    this.buttonRef.current.removeEventListener("keydown", this.handleKeydown);
  }

  clearValue = () => {
    this.props.innerProps.onClick();
  }

  handleClick = () => {
    this.clearValue();
  }

  handleKeydown = (event) => {
    if (event.key === "Enter") {
      this.clearValue();
    }
  }

  render = () => {
    return <WrapperButton ref={this.buttonRef} aria-label="Wyczyść" onClick={this.handleClick}>
      <CloseIcon />
    </WrapperButton>;
  }
}

const WrapperButton = styled.button`
  background: transparent;
  border: none;
  width: 22px;
  height: 22px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: 16px;
    height: 16px;
    fill: #999999;
  }
  &:hover {
    background: #FFBDAD;
    svg {
      fill: #DE350B;
    }
  }
`;

export default CustomMultiValueRemove;
